<template>
    <div class="kt-portlet__head">
        <form class="isprint-filter" autocomplete="off">                
            <div class="container d-flex justify-content-left" style="width: 1000px;">
                <nav aria-label="breadcrumb ">
                    <ol class="breadcrumb indigo lighten-6 first-1  ">
                        <li class="breadcrumb-item grow"><router-link  style="text-decoration: none;margin: -1em;" to="/dashboard"><a class="black-text active-2"><span ><i class="fa fa-home"></i>Home</span></a></router-link></li><i class="fa fa-angle-right" aria-hidden="true" style="transform: translate(0.2rem,0.2rem);"></i>
                        <li class="breadcrumb-item grow"><router-link  style="text-decoration: none;margin: -0.5em;" to="/gestione_pagine"><a class="black-text active-2"><span ><i class="fa fa-window-restore"></i>Pagine</span></a></router-link></li><i class="fa fa-angle-right text-info" aria-hidden="true" style="transform: translate(0.2rem,0.2rem);"></i>
                        <li class="breadcrumb-item  mr-0 pr-0"><a class="black-text active-1" style="text-decoration: none;margin: -0.5em;"><span><i class="fa fa-cog text-info"></i><strong style="margin: 0.5em;" class="text-info">Elementi della pagina {{ this.$root.idPagina }} ({{ this.$root.titoloPagina }})</strong></span></a> </li>
                    </ol>
                </nav>
            </div>
            <button class="btn btn-success float-right btn-sm my-2 my-sm-3" v-on:click="creaElemento()" ><i class="fal fa-plus"></i> Crea Elemento</button>
            <button class="btn btn-primary float-right btn-sm my-2 my-sm-3" v-on:click="salvaOrdine()" ><i class="fal fa-check"></i> Salva Ordine</button>
        </form>
    </div>
    <div class="alert alert-info alert-dismissible fade show" role="alert">
        <strong>INFO:</strong> Cliccare su Salva Ordine dopo aver ordinato gli elementi .
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <br>
    <div class="isprint-grid-container" style="margin-top: 10px;">    
        <div class="container-fluid " style="padding-left: 110px; padding-right: 110px; ">
            <draggable tag="div"  :list="arrayElementi"  class="row w-120">
                <div v-for="elemento in paginatedList.arr" v-bind:key="elemento.ID_ELEMENTO" class="card radius-15 grow shadow" style="width: 16rem; border-width: 2px; border-color:#939393; border-radius: 20px; margin-right:10px!important; margin-left:10px!important; margin-bottom: 40px; opacity: 0.9;">
                    <span class="position-absolute top-0 start-100 translate-middle p-2 border bg-secondary"  style="width: 100px; border-bottom-right-radius: 30%;; height: 100px;transform: translate(-0.5rem, -1.5rem); border-width: 2.5px!important;border-color:#939393" ></span>
                    <div class="card-body text-center">
                        <div class="row">
                            <div class="col-3" >
                                <i class="fal" v-bind:class="getIconTipo(elemento.FK_ID_TIPO)" style='font-size:60px; text-align: center; transform: translate(-0.5rem, -0.8rem);color:#fff'></i>
                            </div>
                            <div class="col">
                                <h6 class="mb-0 mt-5 " style="transform: translate(0,-2.1rem);font-weight: bold;">{{ getDescrizioneTipoElemento(elemento.FK_ID_TIPO)}}</h6>
                            </div>
                        </div>
                            <span>{{ filters.accorciaTesto(elemento.DESCRIZIONE,20) }}</span>
                        </div>
                        <div class="card-footer ">
                            <button  data-toggle="tooltip" data-placement="top" title="Elimina Elemento " class="btn btn-danger text-dark float-right btn-sm" v-on:click="deleteElemento(elemento)"><i class="fal fa-trash-alt"></i></button>
                            <button data-toggle="tooltip" data-placement="top" title="Modifica Elemento "  class="btn btn-warning float-right btn-sm" v-on:click="modificaElemento(elemento)"><i class="fas fa-pencil"></i></button>
                        </div>
                    </div>
            </draggable>
            
        </div>
    </div>
    <div class="modal fade" id="popUpElemento" data-backdrop="true" role="dialog"  aria-modal="true" >
        <div class="modal-dialog" role="document" style="min-width:1200px;"  >
            <div class="modal-content" >
                <div class="modal-header modal-header-warning">
                    <h4 style="color:#fff" class="modal-title"><i class="fal fa-square fa-fw"></i> Elemento</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" >
                    <!-- ZONA FISSA -->
                    <div class="row">
                        <div class="form-group col-md-6" style="margin-bottom:.50rem">
                            <label >TIPOLOGIA:</label>
                            <select class="form-control" v-model="elementoSelezionato.FK_ID_TIPO" :disabled="elementoSelezionato.ID_ELEMENTO>0">
                                <option v-for="tipologia in $root.arrayTipologieElementi" v-bind:value="tipologia.ID_TIPO" v-bind:key="tipologia.ID_TIPO">
                                    {{ tipologia.ID_TIPO+' - '+tipologia.DESCRIZIONE }}
                                </option>
                            </select>
                        </div> 
                        <div class="form-group col-md-6" style="margin-bottom:.50rem">
                            <label >DESCRIZIONE:</label>
                            <input type="text" v-model="elementoSelezionato.DESCRIZIONE" class="form-control" placeholder="Descrizione">
                        </div>
                    </div>
                    <hr>
                    <!-- ZONA VARIABILE A SECONDA DEL VALORE DEL CAMPO FK_ID_TIPO -->
                    <div class="row" v-show="elementoSelezionato.ID_ELEMENTO > 0">
                        <!-- TIPO 1: TITOLO -->
                        <div class="col-12 " v-show="elementoSelezionato.FK_ID_TIPO == 1">
                            <div class="row">
                                <div class="form-group col-md-6" style="margin-bottom:.50rem">
                                    <label >CONTENUTO DEL TITOLO</label>
                                    <input v-model="elementoSelezionato.contenuto.TITOLO" type="text" class="form-control" placeholder="Inserisci Titolo..." aria-label="Titolo" aria-describedby="basic-addon1">
                                </div>
                                <div class="form-group col-md-6" style="margin-bottom:.50rem">
                                    <label >DIMENSIONE CARATTERI</label>
                                    <input v-model="elementoSelezionato.contenuto.DIMENSIONE" type="text" class="form-control" placeholder="Inserisci Dimensione..." aria-label="Dimensione" aria-describedby="basic-addon1">
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-6" style="margin-bottom:.50rem">
                                    <label >FONT</label>
                                    <input v-model="elementoSelezionato.contenuto.FONT" type="text" class="form-control" placeholder="Inserisci Font..." aria-label="Font" aria-describedby="basic-addon1">
                                </div> 
                                <div class="form-group col-md-6" style="margin-bottom:.50rem">
                                    <label >STILE</label>
                                    <input v-model="elementoSelezionato.contenuto.STILE" type="text" class="form-control" placeholder="Inserisci Stile..." aria-label="Stile" aria-describedby="basic-addon1">
                                </div> 
                            </div>
                        </div>
                        <!-- TIPO 2: TESTO -->
                        <div class="col-12 " v-show="elementoSelezionato.FK_ID_TIPO == 2">
                            <div class="row">
                                <div class="form-group col-md-12" style="margin-bottom:.50rem">
                                    <label >CONTENUTO DEL TESTO</label>
                                    <ckeditor :editor="editor" v-model="elementoSelezionato.contenuto.TESTO" :config="editorConfig"></ckeditor>
                                    <!-- 
                                    <textarea v-model="elementoSelezionato.contenuto.DESCRIZIONE" type="text" class="form-control" placeholder="Inserisci Testo..." aria-label="Descrizione" aria-describedby="basic-addon1"></textarea>
                                    -->
                                </div>
                            </div>
                        </div>
                        <!-- TIPO 3: IMMAGINE -->
                        <div class="col-12 " v-show="elementoSelezionato.FK_ID_TIPO == 3">
                            <div class="row">
                                <div class=" col-md-6" style="margin-bottom:.50rem">
                                    <div class="form-group">
                                        <label >Titolo immagine</label>
                                        <input v-model="elementoSelezionato.contenuto.NOME" type="text" class="form-control" placeholder="Inserisci Nome..." aria-label="Nome" aria-describedby="basic-addon1">    
                                    </div>
                                    <div class="col-md-12 shadow card" style="margin-bottom: 0.5rem;text-align: center;padding: 16px;border: 1px solid #ccc;background-color: rgb(221, 221, 221);border-radius: 10px;height:290px;">
                                        <span><strong>Anteprima</strong></span><br/>
                                        <img class="card-image-top" style="width:100%; max-width: 200px; max-height: 200px;margin: auto" v-show="elementoSelezionato.contenuto.URL != ''" :src="getImgPath()" >
                                        <span v-show="elementoSelezionato.contenuto.URL == ''">Immagine non ancora caricata</span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <Upload @onsuccess="successCaricamento()" :w="100" :args="elementoSelezionato.contenuto"></Upload>
                                </div>                                
                            </div>
                        </div>
                        <!-- TIPO 4: ALLEGATO -->
                        <div class="col-12 " v-show="elementoSelezionato.FK_ID_TIPO == 4">
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group col-md-12" style="margin-bottom:.50rem">
                                        <label >NOME ALLEGATO</label>
                                        <input v-model="elementoSelezionato.contenuto.NOME" type="text" class="form-control" placeholder="Inserisci Nome..." aria-label="Nome" aria-describedby="basic-addon1">
                                    </div>
                                    <div class="form-group col-md-12" style="margin-bottom:.50rem">
                                        <label >ESTENSIONE</label>
                                        <input v-model="elementoSelezionato.contenuto.ESTENSIONE" type="text" class="form-control" placeholder="Inserisci Estensione..." aria-label="Estensione" aria-describedby="basic-addon1">
                                    </div> 
                                    <div v-show="elementoSelezionato.contenuto.URL == ''" class="form-group col-md-12 shadow" style="margin-bottom: 0.5rem; margin-top: 50px; text-align: center;padding: 16px;border: 1px solid #ccc;background-color: rgba(221, 221, 221,0,7);border-radius: 10px;height:100px">
                                        <span><strong>Anteprima</strong></span><br/>
                                        <span>Allegato non ancora caricato</span>
                                    </div>
                                    <div v-show="elementoSelezionato.contenuto.ESTENSIONE == 'PDF'" class="alert alert-danger" style=" margin-bottom: 0.5rem; opacity: 10;margin-top: 50px;border: 6px solid #ccc;;border-radius: 10px;height:120px">
                                        <div class="row">
                                            <div class="alert-heading">
                                                <p><strong>Anteprima</strong></p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-2">
                                                <i class="fal" v-bind:class="getClasseAllegatoSelezionato()" style='font-size:50px'></i>
                                            </div>
                                            <div class="col-10" v-if="elementoSelezionato.contenuto != undefined && elementoSelezionato.contenuto.URL != undefined" >
                                                <div class="row horizontal-scroll">
                                                <a target="_blank" :href="getAllegatoPath()">{{elementoSelezionato.contenuto.URL.toString().split('/')[elementoSelezionato.contenuto.URL.toString().split('/').length - 1]}}</a>
                                                </div>
                                            </div>
                                        </div>  
                                    </div>
                                </div>
                                <div class="col-6">
                                    <Upload @onsuccess="successCaricamento()" @onerror="errorCaricamento(elementoSelezionato.messaggio)" :w="100" :args="elementoSelezionato.contenuto"></Upload>
                                </div>
                            </div>
                        </div>
                        <!-- TIPO 5: GALLERY -->
                        <div class="col-12" style="padding-top: 10px;" v-show="elementoSelezionato.FK_ID_TIPO == 5">
                            <div class="row">
                                <div class="col-3" style="height: 50%;">
                                <!-- Set column size to 3 and use d-flex class -->
                                    <Upload @onsuccess="successCaricamento()" :w="100" :args="elementoSelezionato.contenuto" style="width: 100%;"></Upload>
                                <!-- Apply width: 100% to make sure the Upload component takes full width -->
                                </div>
                                <div class="col-9">
                                    <draggable tag="div" :list="elementoSelezionato.contenuto.immagini" class="row w-100">
                                        <div class="col-2" v-for="immagine in elementoSelezionato.contenuto.immagini" :key="immagine.ID_IMMAGINE">
                                            <div class="shadow bg-grey card" style="height: 200px; width: 150px;">
                                                <div class="card-body">
                                                    <img class="card-image-top" style="width: 100%; max-width: 100px; max-height: 100px;" :src="getImgPath(immagine)">
                                                </div>
                                                <div class="card-footer">
                                                    <button class="btn btn-grid btn-danger" @click="deleteImmagine(immagine)"><i class="fal fa-trash-alt"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </draggable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success float-right" v-on:click="salvaElemento()"><i class="fa fa-check"></i> Salva</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

/* import Pagine from '@/components/utils/Pagine.vue' */
import Upload from '@/components/utils/Upload.vue'
import { VueDraggableNext } from 'vue-draggable-next'  
import CKEditor from '@ckeditor/ckeditor5-vue';

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


export default {
        name:"Elementi",
        components:{
            /* Pagine, */
            Upload,
            draggable: VueDraggableNext,
            ckeditor: CKEditor.component,

        },
        data:function(){
        return{
            filters:global.filters,
            search:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:50},
                DESCRIZIONE:{TYPE:'TEXT',VALUE:''}, 
            },
        
            /* searchCr:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:18},
                DESCRIZIONE:{TYPE:'TEXT',VALUE:''},
            }, */
            arrayElementi : new Array(),
            arrayTipologieElementi : new Array(),
            elementoSelezionato : {contenuto:{}},
            upHere: false,
            editor: ClassicEditor,
            editorData: '<p>Content of the editor.</p>',
            editorConfig: {
                // The configuration of the editor.
                 //'extraPlugins': [this.uploader]
            }
        }
    },
    methods: {
        getElementi : function(){
            global.utils.get('/ace/elementi',{FK_ID_PAGINA : this.$root.idPagina}, (response) => {
                this.arrayElementi = response.data;
            });
        },
        creaElemento : function(){
            this.elementoSelezionato = {ID_ELEMENTO:0,contenuto:{},FK_ID_PAGINA :this.$root.idPagina};
            var modal = global.utils.openModal('popUpElemento');

            
        },      
        modificaElemento : function(elemento){
            var modal = global.utils.openModal('popUpElemento');
            this.getElemento(elemento.ID_ELEMENTO);
                
        },
        deleteElemento : function(elemento){
            utils.alert.confirm("Sei sicuro di voler eliminare l'elemento selezionato?",()=>{
               global.utils.delete('/ace/elemento',{ID_ELEMENTO: elemento.ID_ELEMENTO}, (response) => {
                if (response.esito == 0){
                       utils.alert.success(response.messaggio);
                       this.getElementi();
                   }
               });
           },this.$root);
        },
        salvaElemento : function(){
            if(this.elementoSelezionato.ID_ELEMENTO > 0){
                //SE è UNA GALLERY, REIMPOSTO L'ORDINE DELLE IMMAGINI
                if (this.elementoSelezionato.FK_ID_TIPO == 5){
                    for (var i = 0 ; i < this.elementoSelezionato.contenuto.immagini.length ; i++){
                        this.elementoSelezionato.contenuto.immagini[i]['ORDINE'] = (i+1);
                    }
                }
                global.utils.put('/ace/elemento',this.elementoSelezionato, (response) => {
                    if (response.esito == 0){
                        utils.alert.success(response.messaggio);
                        this.getElementi();
                    }
                });
            }
            else{
                //INSERIMENTO
                global.utils.post('/ace/elemento',this.elementoSelezionato,(response)=>{
                    if (response.esito == 0){
                        utils.alert.success(response.messaggio);
                        this.getElemento(response.id_inserito,this.getElementi);
                        
                       /*  global.utils.get('/ace/elemento',{ID_ELEMENTO: response.id_inserito}, (response) => {     
                            this.elementoSelezionato = response.data;    
                            this.getElementi();
                        }); */
                    } 
                });
            }
        },
        salvaOrdine : function(){
            for (var i = 0 ; i < this.arrayElementi.length ; i++){
                this.arrayElementi[i]['ORDINE'] = (i+1);
            } 
            var parametri = {'array' : this.arrayElementi , 'id': this.$root.idPagina};
            console.log(parametri);
            global.utils.put('/ace/elementi/ordine',parametri,(response) => {
                if (response.esito == 0){
                    utils.alert.success(response.messaggio);
                    this.getElementi()
                }
            });
           
        },
        getDescrizioneTipoElemento : function(idTipo){
            var tipo = utils.array.select(this.$root.arrayTipologieElementi,"ID_TIPO",idTipo,1)[0];

            return tipo != undefined ? tipo.DESCRIZIONE:"";
        },

        getColorTipo: function(idTipo){
            switch (idTipo){
                case 1:
                    return 'bg-danger';
                case 2:
                    return 'bg-warning';
                case 3:
                    return 'bg-success';
                case 4:
                    return 'bg-info';
                case 5:
                    return 'bg-primary';
            }                    
        },
        getIconTipo: function(idTipo){
            switch (idTipo){
                case 1:
                    return 'fa-heading';
                case 2:
                    return 'fa-comment-alt';
                case 3:
                    return 'fa-image';
                case 4:
                    return 'fa-paperclip';
                case 5:
                    return 'fa-images';
            }                    
        },
        successCaricamento : function(){
            utils.alert.success("Operazione correttamente eseguita") ;
            this.getElemento();
        },

        errorCaricamento: function(messaggio){
            utils.alert.warning(messaggio)
        },
        getElemento : function(idElemento = 0,handler = null){
            var id = this.elementoSelezionato.ID_ELEMENTO;
            if (idElemento > 0){
                id = idElemento;
            }
            global.utils.get('/ace/elemento',{ID_ELEMENTO: id}, (response) => {     
                this.elementoSelezionato = response.data;    
                if (this.elementoSelezionato.FK_ID_TIPO == 3){
                    this.elementoSelezionato.contenuto.modalita = 'ACE_uploadImg';
                }
                if (this.elementoSelezionato.FK_ID_TIPO == 4){
                    this.elementoSelezionato.contenuto.modalita = 'ACE_uploadDoc';
                }
                if (this.elementoSelezionato.FK_ID_TIPO == 5){
                    this.elementoSelezionato.contenuto.modalita = 'ACE_uploadImgGallery';
                } 
                if (handler != null){
                    handler();
                }
            });
        },
        getImgPath : function(immagine = null){
            if (immagine == null){
                return utils.BASE_API + "../../UPLOAD/" + this.elementoSelezionato.contenuto.URL;
            }
            else{
                return utils.BASE_API + "../../UPLOAD/" + immagine.URL;
            }
            
        },
        
        deleteImmagine : function(immagine){                
            utils.alert.confirm("Sei sicuro di voler eliminare l'elemento selezionato?",()=>{
                global.utils.delete('/ace/immagine',{ID_IMMAGINE: immagine.ID_IMMAGINE}, (response) => { 
                    this.getElemento();
                });                
            },this.$root);
        },
        getClasseAllegatoSelezionato : function(){
            if (this.elementoSelezionato.FK_ID_TIPO == 4){
                switch (this.elementoSelezionato.contenuto.ESTENSIONE){
                    case 'PDF':
                        return 'fa-file-pdf';
                    case 'XLSX':
                    case 'XLS':
                    case 'CSV':
                        return 'fa-file-excel';
                    default:
                        return 'fa-file';
                }                    
            }
            
        },
            getAllegatoPath : function(){
                if(this.elementoSelezionato.contenuto.ESTENSIONE == "PDF"){
                   /*  return window.open('C:/xampp/htdocs/dryland_2/CORE/UPLOAD'+ this.elementoSelezionato.contenuto.URL, '_blank'); */
                   return utils.BASE_API + "../../UPLOAD/" + this.elementoSelezionato.contenuto.URL;
                }  
            },
    },
    computed : {
        
        paginatedList(){
            var arr = utils.inGrid(this.arrayElementi,this.search);
            return arr;
        },
        /* paginatedListCr(){
            if (this.arrayCentriRicavo == undefined || this.arrayCentriRicavo == null)
                return new Array();
            var arr = global.utils.inGrid(this.arrayCentriRicavo,this.searchCr);
            return arr;
        }, */
    },
    created : function(){
        this.getElementi();
    },
}
</script>
<style>
/* h1 span {
  background: red;
  color: #fff;
  padding: 0 20px;
} */
.grow { 
transition: all .2s ease-in-out; 
}

.grow:hover { 
transform: scale(1.1); 
}

.horizontal-scroll {
    width: 100%;
    overflow-x: auto;
    scrollbar-width: thin;

}
.cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin: 4rem 5vw;
  padding: 0;
  list-style-type: none;
}

.card {
  position: relative;
  display: block;
  height: 100%;  
  border-radius: calc(var(--curve) * 1px);
  overflow: hidden;
  text-decoration: none;
}

.card__image {      
  width: 100%;
  height: auto;
}

.card__overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;      
  border-radius: calc(var(--curve) * 1px);    
  background-color: var(--surface-color);      
  transform: translateY(100%);
  transition: .2s ease-in-out;
}

.card:hover .card__overlay {
  transform: translateY(0);
}

.card__header {
  position: relative;
  display: flex;
  align-items: center;
  gap: 2em;
  padding: 2em;
  border-radius: calc(var(--curve) * 1px) 0 0 0;    
  background-color: var(--surface-color);
  transform: translateY(-100%);
  transition: .2s ease-in-out;
}

.card__arc {
  width: 80px;
  height: 80px;
  position: absolute;
  bottom: 100%;
  right: 0;      
  z-index: 1;
}

.card__arc path {
  fill: var(--surface-color);
  d: path("M 40 80 c 22 0 40 -22 40 -40 v 40 Z");
}       

.card:hover .card__header {
  transform: translateY(0);
}

.card__thumb {
  flex-shrink: 0;
  width: 50px;
  height: 50px;      
  border-radius: 50%;      
}

.card__title {
  font-size: 1em;
  margin: 0 0 .3em;
  color: #6A515E;
}

.card__tagline {
  display: block;
  margin: 1em 0;
  font-family: "MockFlowFont";  
  font-size: .8em; 
  color: #D7BDCA;  
}

.card__status {
  font-size: .8em;
  color: #D7BDCA;
}

.card__description {
  padding: 0 2em 2em;
  margin: 0;
  color: #D7BDCA;
  font-family: "MockFlowFont";   
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

body {
            background: #eee;    
        }

        .container {
            margin-top: 250px;
        }


        .breadcrumb>li+li:before {
            content: "" !important;
        }

        .breadcrumb {
            padding: 20px;
            font-size: 17px;
            color: #242424 !important;
            letter-spacing: 1px;
            border-radius: 5px !important;
        }

     
        .first-1 {
            background-color: rgba(255, 255, 255, 0) !important;
        }


        a {
            text-decoration: none !important;
            color: #242424 !important;
        }

        a:focus,
        a:active {
            outline: none !important;
            box-shadow: none !important;
        }

        .active-1  , .active-2{
            font-size: 17px !important;
            font-family: 'Source Sans Pro', sans-serif;;
            padding-bottom: 12px !important;
            padding-top: 12px !important;
            padding-right: 25px !important;
            padding-left: 25px !important;
        }

        

        
</style>